import { Button, ButtonProps } from "@mui/material";
import React from "react";

interface CustomButtonProps extends ButtonProps {
  label?: string;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  children,
  sx,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        padding: "8px 16px",
        fontWeight: 600,
        ...sx,
      }}
    >
      {label || children}
    </Button>
  );
};
